import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Statusbar.scss';
import './MapScale.scss';
import './Attribution.scss';
export function Statusbar(props) {
    return (_jsxs("div", { className: 'sg-statusbar', children: [props.mapScaleId && _jsx("div", { className: 'sg-mapScale', id: props.mapScaleId }), props.children && _jsx("div", { className: 'sg-attribution sg-u-userContent', children: props.children })] }));
}
//# sourceMappingURL=Statusbar.js.map